let patrnName = /[`~!@$%\^&*()=\+\[\{\]\}\\\|;:\'\"<>\?\/！￥…（）—【】、；：‘’“”，《。》？～＠＃％＆×－＝＋｛｝＼｜｀＄＾＊＿［］＇＂＜．＞／]+/; // 姓名非法字符集
let cardNumberPatrn = /[A-Za-z0-9]/; // 证件非法字符校验
let cardSFZ = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/; // 居民身份证位数校验
let areaCode = /^(14|11|13|34|63|31|37|64|22|62|15|41|52|46|61|35|54|36|21|51|12|65|42|44|33|50|32|45|43|23|53|81|82|83)$/; // 行政区校验（身份证）
let patrnHuZhao = /^[A-Za-z -.,]+$/; // 护照姓名校验
let GACard = /(^(810000|820000)\d{12}$)|(^(810000|820000)\d{11}(\d|X|x)$)/; // 港澳居民居住证
let TWCard = /(^(830000)\d{12}$)|(^(830000)\d{11}(\d|X|x)$)/; // 台湾居民居住证
let GATXZCard = /(^(H|M|h|m)\d{8}$)|(^(H|M|h|m)\d{10}$)/; // 港澳通行证
let HZandTWTXZCard = /^[A-Za-z0-9]{6,20}$/; // 护照、台湾通行证
let JunShiCard = /^[A-Za-z0-9\u4e00-\u9fa5]{6,20}$/; // 军官证、士官证、消防、幼儿其他
let NoCard = /^(LS)\d{18}$/; // 其他无证件
let mobilePatrn = /^(1\d{10})$/; // 手机号码
let numberReg = /^([0-5])$/; // 户籍年份校验 0-5
let registerIdReg = /^\d{10}$/; // 登记编号校验
let agePatrn = /^(1[5-9]|([2-9][0-9]))$/;  // 年龄校验 15-99
let JSscore = /^([0-9]|(1[0-9]|20))$/; // [0-20]
let countAddReg = /^(0|1|([1-9]\d{0,1}))$/; // 活动次数校验 0-99
let insuranceMonth = /^([1-9]\d{0,2}|0)$/; // 累计缴纳社保月数0-999
let rangeoneYear = /^([0-9]|(1[0-2]))$/; // 0-12
let positiveInt = /(^[1-9]\d*$)/; // 正整数校验
let accountReg = /^([a-zA-Z][a-zA-Z0-9_]{5,19})$/; // 账号校验
let passwordReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/; // 密码校验

export default {
  patrnName,
  cardNumberPatrn,
  cardSFZ,
  areaCode,
  patrnHuZhao,
  GACard,
  TWCard,
  GATXZCard,
  HZandTWTXZCard,
  JunShiCard,
  NoCard,
  mobilePatrn,
  numberReg,
  registerIdReg,
  agePatrn,
  JSscore,
  countAddReg,
  insuranceMonth,
  rangeoneYear,
  positiveInt,
  accountReg,
  passwordReg
}